import { BaseEntityDTO, IBaseEntityDTO } from './';

export interface ITeamRoleDTO extends IBaseEntityDTO {
  name: string;
}

export class TeamRoleDTO extends BaseEntityDTO implements ITeamRoleDTO {
  name: string;

  constructor(data?: Partial<TeamRoleDTO>) {
    super();
    this.name = data?.name ?? '';
  }
}
